import state from './moduleRuleTemplateState'
import actions from './moduleRuleTemplateActions'
import getters from './moduleRuleTemplateGetters'
import mutations from './moduleRuleTemplateMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
